import styled, { css } from "styled-components/macro";
import { marginSpacing } from "components/common/mixins";

const LargeTitle = styled.h2`
  font-family: ${(props) => props.theme.fontStyles.headings};
  font-size: 3.2rem;
  font-weight: 600;
`;

const MediumTitle = styled.h2`
  font-family: ${(props) => props.theme.fontStyles.headings};
  font-size: 4rem;
  font-weight: normal;
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
`;

const MediumSmalTitle = styled(MediumTitle)`
  font-size: 2.4rem;
`;

const SmallTitle = styled.h5`
  font-family: ${(props) => props.theme.fontStyles.subHeadings};
  font-size: 1.8rem;
  font-weight: bold;
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
`;

const SectionTitle = styled.h2`
  margin-bottom: 3.4rem;
  font-size: 2.5rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.colorDark};
`;

const PageTitle = styled.h1<{ padding?: any }>`
  font-size: 3rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};
  padding: ${(props) => props.padding};
`;

const FormTitle = styled.h3<{
  $primary?: any;
  $marginBottom?: any;
  $marginTop?: any;
  $centered?: any;
  $small?: any;
}>`
  font-family: ${(props) => props.theme.fontStyles.subHeadings};
  font-size: ${(props) => (props.$small ? "18px" : "24px")};
  font-weight: 600;

  ${({ $centered }) =>
    $centered &&
    css`
      text-align: center;
    `}

  ${marginSpacing}

  ${({ $primary }) =>
    $primary &&
    css`
      color: ${(props) => props.theme.colors.primary};
    `}
`;

const LeftTitle = styled.h3`
  color: ${(props) => props.theme.colors.primary};
  font-size: 2.4rem;
  font-weight: 600;
  text-align: left;
  margin-bottom: 1rem;
`;

export {
  LargeTitle,
  LeftTitle,
  MediumTitle,
  MediumSmalTitle,
  SmallTitle,
  SectionTitle,
  PageTitle,
  FormTitle,
};
